import Settings from "layouts/pages/users/profile/settings";

// Authentication pages
import SignIn from "layouts/authentication/sign-in";

// RasPm Dashboard components
import MDAvatar from "components/MDAvatar";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import profilePicture from "assets/images/user.webp";

// client
import NewClient from "layouts/pages/projects/clients/add";
import EditClient from "layouts/pages/projects/clients/edit";
import ViewClient from "layouts/pages/projects/clients/view";

//Categories
import NewCategory from "layouts/pages/projects/categories/add";
import CategoriesDataTables from "layouts/pages/projects/categories/view";
import EditCategory from "layouts/pages/projects/categories/edit";

// companies
import EditCompany from "layouts/pages/projects/companies/edit";
import ViewCompany from "layouts/pages/projects/companies/view";
import NewCompany from "layouts/pages/projects/companies/add";

// projects
import AddProject from "layouts/pages/projects/projects/add";
import EditProject from "layouts/pages/projects/projects/edit";
import ViewProjects from "layouts/pages/projects/projects/view";
import EditProjectManagers from "layouts/pages/projects/projects/EditPmManagers";

// milestones
import ViewMilestones from "layouts/pages/projects/milestones/view";
import AddMilestone from "layouts/pages/projects/milestones/add";
import EditMilestone from "layouts/pages/projects/milestones/edit";

// issues
import ViewIssues from "layouts/pages/projects/issues/view";
import AddIssue from "layouts/pages/projects/issues/add";
import EditIssue from "layouts/pages/projects/issues/edit";

// risks
import ViewRisks from "layouts/pages/projects/risks/view";
import AddRisk from "layouts/pages/projects/risks/add";
import EditRisk from "layouts/pages/projects/risks/edit";
import InfoProject from "layouts/pages/projects/projects/Info";
// users
import NewUser from "layouts/pages/users/add";
import ViewUsers from "layouts/pages/users/view";
// import EditUser from "layouts/pages/users/edit";

// PowerStations
import PowerStationsDataTables from "layouts/pages/powerstations/powerstations/view";
import STDataTables from "layouts/pages/powerstations/st/view";
import GTDataTables from "layouts/pages/powerstations/gt/view";
import MetricsDataTables from "layouts/pages/powerstations/metrics/view";
import TableDataView from "layouts/pages/powerstations/table/view";
import TransactionsDataTables from "layouts/pages/powerstations/transactions/view";
import Cookies from "js-cookie";

// HR
import CompaniesDataTable from "layouts/pages/hr/companies/view/index";
import DepartmentsDataTable from "layouts/pages/hr/departments/view/index";
import PositionsDataTable from "layouts/pages/hr/positions/view/index";

// Employees
import EmployeesDataTable from "layouts/pages/hr/employees/view/index";

let displayName = Cookies.get("displayName");
let userTypeName = Cookies.get("userTypeName");
if (!displayName || displayName === "undefined" || displayName === "null" || displayName === "") {
  displayName = "لا يوجد اسم";
}

const SuperAdmin="SuperAdmin".toUpperCase();
const Admin="Admin".toUpperCase();
const CompanyAdmin="CompanyAdmin".toUpperCase();
const ProjectManager="ProjectManager".toUpperCase();
const Accountant="Accountant".toUpperCase();
const PowerStationAdmin="PowerStationAdmin".toUpperCase();

let justroutes = [
  {
    key: "EditClient",
    route: "/projects/client/edit",
    path: "/projects/client/edit",
    component: <EditClient />,
  },
  {
    key: "NewClient",
    route: "/pages/projects/clients/add",
    path: "/pages/projects/clients/add",
    component: <NewClient />,
  },
  // add category
  {
    key: "NewCategory",
    route: "/pages/projects/categories/add",
    path: "/pages/projects/categories/add",
    component: <NewCategory />,
  },
  {
    key: "EditCategory",
    route: "/projects/categories/edit",
    path: "/projects/categories/edit",
    component: <EditCategory />,
  },
  {
    key: "NewCompany",
    route: "/pages/projects/company/add",
    path: "/pages/projects/company/add",
    component: <NewCompany />,
  },
  {
    key: "EditCompany",
    route: "/projects/company/edit",
    path: "/projects/company/edit",
    component: <EditCompany />,
  },
  {
    key: "AddProject",
    route: "/pages/projects/project/add",
    path: "/pages/projects/project/add",
    component: <AddProject />,
  },

  {
    key: "EditProject",
    route: "/projects/project/edit",
    path: "/projects/project/edit",
    component: <EditProject />,
  },
  {
    key: "EditProjectManagers",
    route: "/pages/projects/EditProjectManagers",
    path: "/pages/projects/EditProjectManagers",
    component: <EditProjectManagers />,
  },
  {
    key: "ViewMilestones",
    route: "/pages/projects/milestones/view",
    path: "/pages/projects/milestones/view",
    component: <ViewMilestones />,
  },
  {
    key: "AddMilestone",
    route: "/pages/projects/milestones/add",
    path: "/pages/projects/milestones/add",
    component: <AddMilestone />,
  },
  {
    key: "EditMilestone",
    route: "/pages/projects/milestones/edit",
    path: "/pages/projects/milestones/edit",
    component: <EditMilestone />,
  },
  {
    key: "ViewIssues",
    route: "/pages/projects/issues/view",
    path: "/pages/projects/issues/view",
    component: <ViewIssues />,
  },

  {
    key: "AddIssue",
    route: "/pages/projects/issues/add",
    path: "/pages/projects/issues/add",
    component: <AddIssue />,
  },
  {
    key: "EditIssue",
    route: "/pages/projects/issues/edit",
    path: "/pages/projects/issues/edit",
    component: <EditIssue />,
  },
  {
    key: "ViewRisks",
    route: "/pages/projects/risks/view",
    path: "/pages/projects/risks/view",
    component: <ViewRisks />,
  },
  {
    key: "AddRisk",
    route: "/pages/projects/risks/add",
    path: "/pages/projects/risks/add",
    component: <AddRisk />,
  },
  {
    key: "EditRisk",
    route: "/pages/projects/risks/edit",
    path: "/pages/projects/risks/edit",
    component: <EditRisk />,
  },
  {
    key: "InfoProject",
    route: "projectinfo",
    path: "projectinfo",
    component: <InfoProject />,
  },
  {
    key: "NewUser",
    route: "/pages/users/add",
    path: "/pages/users/add",
    component: <NewUser />,
  },
  {
    key: "ViewUsers",
    route: "/pages/users/view",
    path: "/pages/users/view",
    component: <ViewUsers />,
  },
  // {
  //   key: "UpdateUser",
  //   route: "/users/update/:id",
  //   path: "/users/update/:id",
  //   component: <EditUser />,
  // },
  {
    key: "powerStations",
    route: "/power-stations",
    path: "/power-stations",
    component: <PowerStationsDataTables />,
  },
  {
    key: "steamTurbines",
    route: "/steam-turbines",
    path: "/steam-turbines",
    component: <STDataTables />,
  },
  {
    key: "gasTurbines",
    route: "/gas-turbines",
    path: "/gas-turbines",
    component: <GTDataTables />,
  },
  {
    key: "powerStationMetrics",
    route: "/power-stations/metrics",
    path: "/power-stations/metrics",
    component: <MetricsDataTables />,
  },
  {
    key: "transactions",
    route: "/powerstations/transactions",
    path: "/powerstations/transactions",
    component: <TransactionsDataTables />,
  },
];

const routes = [
  {
    type: "collapse",
    name: displayName,
    key: "brooklyn-alice",
    icon: <MDAvatar src={profilePicture} alt="Brooklyn Alice" size="sm" />,
    collapse: [
  
      {
        name: "ملفي الشخصي",
        key: "profile-overview",
        key: "my-profile",
        route: "/pages/account/my-profile",
        component: <Settings />,
        icon: <Icon fontSize="small">person</Icon>,
      },
      {
        name: "تسجيل خروج",
        key: "logout",
        route: "/authentication/sign-in",
        component: <SignIn />,
        icon: <Icon fontSize="small">logout</Icon>,
      },
    ],
  },
  // { type: "divider", key: "divider-0" },
  // { type: "title", title: "ادارة", key: "newclient", component: <NewClient /> 
  //   ,    userTypes:[SuperAdmin],

  // },
   {
    type: "collapse",
    name: "ادارة",
    key: "dashboards",
    userTypes:[SuperAdmin],
    
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {

        name:"المستخدمين",
        key:"users",
        route:"/dashboards/users",
        component:<ViewUsers/>,
        icon: <Icon fontSize="small">group</Icon>,
      }
    
    ],
  },
  // { type: "divider", key: "divider-0" },
  // { type: "title", title: "ادارة الموارد البشرية", key: "HRTitle", component: <NewClient /> 
  //   ,    userTypes:[SuperAdmin],

  // },
   {
    type: "collapse",
    name: "الموارد البشرية",
    key: "HRCollapse",
    userTypes:[SuperAdmin,CompanyAdmin],
    
    icon: <Icon fontSize="medium">manage_accounts</Icon>,
    collapse: [
      {

        name:"الشركات",
        key:"Companies",
        route:"/hr/Companies",
        component:<CompaniesDataTable/>,
        icon: <Icon fontSize="small">business</Icon>,
      },
      {
        name:"الاقسام",
        key:"Departments",
        route:"/hr/Departments",
        component:<DepartmentsDataTable/>,
        icon: <Icon fontSize="small">account_tree</Icon>,
      },
      {
        name:"المسميات الوظيفية",
        key:"Positions",
        route:"/hr/Positions",
        component:<PositionsDataTable/>,
        icon: <Icon fontSize="small">work</Icon>,
      },
      {
        name: "الموظفين",
        key: "employees",
        icon: <Icon fontSize="small">people</Icon>,
        route: "/hr/employees",
        component: <EmployeesDataTable />,
      },
    
    ],
  },

  // { type: "title", title: "المشاريع", key: "title-pages3", userTypes:[SuperAdmin , ProjectManager] },
  {
    type: "collapse",
    name: "المشاريع",
    key: "projects",
    icon: <Icon fontSize="medium">folder_special</Icon>,
    userTypes:[SuperAdmin , ProjectManager],
    collapse: [
      {
        name: "العملاء",
        key: "viewclients",
        route: "/pages/projects/viewclients",
        component: <ViewClient />,
        userTypes:[SuperAdmin],
        icon: <Icon fontSize="small">person_outline</Icon>,
      },
      {
        name: "الفئات",
        key: "viewcategroies",
        route: "/pages/projects/viewcategroies",
        component: <CategoriesDataTables />,
        userTypes:[SuperAdmin],
        icon: <Icon fontSize="small">category</Icon>,
      },
      // {
      //   name: "الشركات",
      //   key: "viewcompanies",
      //   route: "/pages/projects/viewcompanies",
      //   component: <CompaniesDataTable />,
      //   userTypes:[SuperAdmin],
      // },
      {
        name: "المشاريع",
        key: "viewprojects",
        route: "/pages/projects/viewprojects",
        component: <ViewProjects />,
        icon: <Icon fontSize="small">assignment</Icon>,
      },
    ],
  },
  // { type: "title", title: "المحطات", key: "title-pages2"  , userTypes:[SuperAdmin , PowerStationAdmin] },

  {
    type: "collapse",
    name: "المحطات",
    key: "power-stations",
    icon: <Icon fontSize="medium">electric_bolt</Icon>,
    userTypes:[SuperAdmin , PowerStationAdmin],
    collapse: [
      {
        name: "المحطات",
        key: "power-stations-list",
        route: "/pages/powerstations/powerstations/power-stations-list",
        component: <PowerStationsDataTables />,
        userTypes:[SuperAdmin ],
        icon: <Icon fontSize="small">factory</Icon>,
      },
      {
        name: "التوربينات البخارية",
        key: "st-units",
        route: "/pages/powerstations/st/st-units",
        component: <STDataTables />,
        icon: <Icon fontSize="small">cyclone</Icon>,
      },
      {
        name: "التوربينات الغازية",
        key: "gt-units",
        route: "/pages/powerstations/gt/gt-units",
        component: <GTDataTables />,
        icon: <Icon fontSize="small">stream</Icon>,
      },
      {
        name: "القراءات اليومية", 
        key: "transactions",
        route: "/powerstations/transactions",
        component: <TransactionsDataTables />,
        icon: <Icon fontSize="small">analytics</Icon>,
      },
    ],
  },
  


];
justroutes.map((route) => {
  routes.push(route);
});
export default routes;
